import { useEffect } from "react";
import { minimizeSidebarOnTablet } from "utils/sidebarHelper";

/**
 * Custom hook to automatically minimize the sidebar on tablet screens
 * 
 * Usage:
 * ```tsx
 * function MyComponent() {
 *   useAutoMinimizeSidebar();
 *   // ... rest of component
 * }
 * ```
 * 
 * This hook will:
 * - Minimize the sidebar when the component mounts on tablet screens (768px - 1024px)
 * - Maintain the minimized state when window is resized within tablet range
 * - Clean up event listeners on unmount
 */
export const useAutoMinimizeSidebar = () => {
  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      minimizeSidebarOnTablet();
    }, 100);

    // Also handle window resize to maintain minimized state on tablet
    const handleResize = () => {
      minimizeSidebarOnTablet();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
};

